

import Vue from 'vue';
import BaseButton from "@/components/buttons/BaseButton.vue";
import {Login} from "@/model/Login";
import {AuthorizationRequests} from "@/scripts/ProfiControlRequests/AuthorizationRequests";
export default Vue.extend({
  components: {BaseButton},
  data:() => ({
        model: new Login(),
        showPassword: false,
        showError: false,
    }),
  methods: {
    Login() {
      let url = `${this.$config.GatewayUrl}/api/v1/admin/login`;
      AuthorizationRequests.Login(url, this.model);
    },
  },
  watch:{
    'model.HasError': function (){
      if(this.model.HasError){
        this.showError = true;
        this.model.HasError = false;
        setTimeout(() => {
          this.showError = false
        }, 5000)
      }
    },
    'model.PermissionMap':function (){
      if(!!this.model.PermissionMap){
        this.$emit('authorize', this.model.PermissionMap);
      }
    },
    'model.Token': function () {
      if(!!this.model.Token){
        this.$emit('logged-in', this.model.Token);
      }
    }
  }
})
